import { makeStyles } from '@material-ui/core';
import { tcsmColors } from '../../theme-constants/colors';




export const employeeSearchTableStyles = makeStyles((theme) => ({
    searchTable: {
        border: `1px solid ${tcsmColors.greySeven}`,
        boxShadow: '0px 1px 1px rgba(48, 48, 48, 0.3)',
        borderRadius: '3px',
        '& .employee-search': {
            '&-table': {
                '&-row': {
                    margin: 0,
                    padding: 0,
                    [theme.breakpoints.up('sm')]: {
                        display: 'table',
                        tableLayout: 'fixed',
                        width: '100%',
                        maxWidth: '100%',
                    },
                    '&-cell': {
                        [theme.breakpoints.up('sm')]: {
                            display: 'table-cell',
                            overflowWrap: 'break-word',
                        },
                        padding: theme.spacing(1),

                        '&.no-match-cell': {
                            width:'75%',
                        },
                       
                        '&:last-child': {
                            [theme.breakpoints.up('sm')]: {
                                paddingRight: theme.spacing(3),
                            },
                        },
                        '&.icon-row-title': {
                            [theme.breakpoints.up('sm')]: {
                                paddingLeft: theme.spacing(2.5),
                            },
                        },
                 
                    },
                    
                },
                '&-content': {
                    border: `1px solid ${tcsmColors.greySix}`,
                    '& >.employee-search-item-accordion': {
                        marginBottom: 0,
                        marginTop: 0,
                       
                    },

                    '& > div:nth-child(even)': {
                        backgroundColor: tcsmColors.greySeven,
                    },

                    '& .not-provided-text': {
                        color: tcsmColors.greyThree,
                    },
                },
                '&-radio': {
                    display: 'flex',
                    '& input': {
                        margin: '.25rem .5rem 0 0',
                    },
                    '& svg': {
                        width: '1rem',
                        height: '1rem',
                        fill: tcsmColors.blue,
                        flex: '0 0 auto',
                        margin: '.25rem .5rem 0 0',
                    },
                },
                '&-pagination': {
                    padding: theme.spacing(1),
                },
            },
            '&-group': {
                marginBottom: theme.spacing(1),
            },
            '&-item': {
                '&-accordion': {
                    boxShadow: 'none',
                    '&:before': {
                        display: 'none',
                    },
                    '&-summary': {
                        padding: 0,
                        position: 'relative',
                        '& > div': {
                            margin: 0,
                        },
                        '& .MuiAccordionSummary-expandIcon': {
                            position: 'absolute', // Position trigger button due to limited html editing capabilities of MUI accordion
                            right: 0,
                            margin: 0,
                            top: 0,

                            '& svg': {
                                fill: tcsmColors.blue,
                            },
                        },

                    },

                    '& .MuiAccordionDetails-root': {
                        padding: theme.spacing(1),
                        [theme.breakpoints.up('sm')]: {
                            padding: theme.spacing(1.25),
                        },
                    },

                },
                '&-name': {
                    display: 'flex',
                
                    '&-text': {
                        '&:first-child': {
                            [theme.breakpoints.up('sm')]: {
                                marginLeft: theme.spacing(1.5),
                            },
                        },
                    },
                    '& .clergy-icon': {
                        width: '1rem',
                        height: '1rem',
                        fill: tcsmColors.blue,
                        flex: '0 0 auto',
                        marginRight: theme.spacing(.5),
                    },
                },
                '&-status': {
                    display: 'flex',
                    '& svg': {
                        width: '1.25rem',
                        height: '1.25rem',
                        marginRight: theme.spacing(.5),
                    },
                    '&-missing': {
                        '& svg': {
                            fill: tcsmColors.yellow,
                        },
                    },
                    '&-complete': {
                        '& svg': {
                            fill: tcsmColors.green,
                        },
                    },

                },

                '&-content': {
                    border: `1px solid ${tcsmColors.greyFour}`,
                    padding: theme.spacing(1.25),
                    '&-column': {
                        paddingBottom: theme.spacing(.75),
                        paddingRight: theme.spacing(.5),
                    },
                    '& .table-pagination': {
                        padding: theme.spacing(1),
                    },
                },
            },
        },
        '& .row-header-text, & .row-tooltip': {
            paddingRight: theme.spacing(2),
        },
        '& .table-pagination': {
            padding: theme.spacing(1),
        },
    },



}));
